import { IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";

/**
 * GenerateCentroCustoSecundarioColumnsDefinition
 */

type Props = {
  handleActionEdit: (idCentroCusto: number | null) => void,
  handleActionDelete: (idCentroCusto: number) => void,
};

export const GenerateCentroCustoSecundarioColumnsDefinition = ({
  handleActionEdit,
  handleActionDelete,
}: Props): GridColDef[] => {
  return [
    {
      field: "codigo",
      filterable: false,
      headerName: "Código",
      flex: 1,
      minWidth: 120,
      sortable: false,
    },
    {
      field: "descricao",
      filterable: false,
      headerName: "Descrição",
      flex: 1,
      minWidth: 120,
      sortable: false,
    },
    {
      field: 'idCentroCustoSecundario',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      minWidth: 100,
      flex: 0,
      renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton onClick={() => handleActionEdit(params.value)}>
              <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
            </IconButton>

            <IconButton onClick={() => handleActionDelete(params.value)}>
              <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
            </IconButton>
          </div>
        );
      },
    }
  ];
}